const companyData = [
    {
        image: "coca-cola.svg",
        link: "/company/Coca-Cola"
    },
    {
        image: "pepsi.svg",
        link: "/company/pepsi-Co"
    },
    {
        image: "cadbury.svg",
        link: "/company/Cadbury"
    },
    {
        image: "dabur.png",
        link: "/company/Dabur"
    },
    {
        image: "sudha.png",
        link: "/company/Sudha"
    },
    {
        image: "osam.jpg",
        link: "/company/Osam"
    },
    {
        image: "j.png",
        link: "/company/Johnson-and-Johnson"
    },
    {
        image: "haldirams.png",
        link: "/company/Haldirams"
    },
    {
        image: "fortune.png",
        link: "/company/Fortune"
    },
    {
        image: "dettol.jpg",
        link: "/company/Dettol"
    },
    {
        image: "dabur.png",
        link: "/company/Dabur"
    },
    {
        image: "daawat.png",
        link: "/company/Daawat"
    },
    {
        image: "colgate.png",
        link: "/company/Colgate"
    },
    {
        image: "amul.png",
        link: "/company/Amul"
    },
    {
        image: "aashirvad.png",
        link: "/company/Aashirvad"
    },
    {
        image: "aashirvad-svasti.png",
        link: "/company/Aashirvaad-Svasti"
    }
];

export default companyData;